<template>
    <BreadCrumb PageTitle="Listes des virements" />
    <ListeVirement />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeVirement from "../../components/Virement/ListeVirement.vue";
  
  
  export default defineComponent({
    name: "ListeVirementPage",
    components: {
      BreadCrumb,
      ListeVirement,
    },
  });
  </script>